export default {
    exportBehavior_fileFormat: "File Format",
    exportBehavior_reportType: "Report Type",
    exportBehavior_simpleReport: "Simple Report",
    exportBehavior_detailedReport: "Detailed Report",
    exportBehavior_metricValueRequired: 'Metric Values is required',
    exportBehavior_exportBehavior: "Export Behavior",
    exportBehavior_exportGenerated : "The export is being generated",
}
